
export default function EnterpriseSidebar({ activeKey, onNavigate, items = [] }) {
  return <aside className="enterprise-sidebar"><div className="enterprise-brand">ShiftBridge</div>
    <nav aria-label="Enterprise sections">{items.map(item => <div key={item.key} className={item.key === 'system' ? 'enterprise-secondary-nav' : undefined}>
      <button type="button" aria-current={activeKey === item.key ? 'page' : undefined} onClick={() => onNavigate?.(item.key)}><span>{item.label}</span>{item.badge ? <span className="enterprise-nav-badge">{item.badge}</span> : null}</button>
    </div>)}</nav></aside>;
}

